export const getProviderLogo = provider =>
  provider
    ? provider.startsWith("yahoo")
      ? ""
      : provider.startsWith("bing")
      ? ""
      : provider.startsWith("google")
      ? "search/google.png"
      : "search.png"
    : "search.png";
